import React from 'react';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import {
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
} from 'applications/scribe/instrumentations/track';
import ShopifyTrackEventContext from 'views/v2/shopify-home/track-event';
import { EMPLOYEES } from 'actions/endpoint-constants';
import iconRedirectSvg from 'public/images/icon-redirect.svg';
import styles from './enterprise-account-content.less';

const localeKeyPrefix =
  'shopify.settings.manageEmployeeSection.enterpriseAccount';

const EnterpriseAccountContent = () => {
  const trackCtx = React.useContext(ShopifyTrackEventContext);

  const fireManageEmployeesTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.MANAGE_EMPLOYEES,
    });
  };

  const clickSetupEnterpriseHandler = () => {
    fireManageEmployeesTrackEvent();
    const { endpoints } = window.Grab.config;
    window.open(`${endpoints.gfbAdmin}${EMPLOYEES}`);
  };

  return (
    <div className={styles.EnterpriseAccountContentPanel}>
      <div className={styles.ActionButtonsContainer}>
        <Button
          className={styles.ActionButton}
          type="link"
          onClick={clickSetupEnterpriseHandler}
        >
          {I18n.t(`${localeKeyPrefix}.button.label`)}&nbsp;
          <img src={iconRedirectSvg} alt="redirectIcon" />
        </Button>
      </div>
    </div>
  );
};

export default EnterpriseAccountContent;
